import { MonedaConstants } from "../../../types/typesConstants";

export const DetraccionCell = ({
  moneda_prefijosunat,
  monedabase_prefijo,
  moneda_prefijo,
  totalesdetraccion,
}) => {
  return (
    <>
      {moneda_prefijosunat === MonedaConstants.PEN && (
        <div>
          <b>{monedabase_prefijo}</b>
          {` ${parseFloat(totalesdetraccion?.montodetraccion).toFixed(2)}`}
        </div>
      )}
      {moneda_prefijosunat !== MonedaConstants.PEN && (
        <>
          <div>
            <b>{monedabase_prefijo}</b>
            {` ${parseFloat(totalesdetraccion?.montodetraccion).toFixed(2)}`}
          </div>
          <sub>
            <b>{moneda_prefijo}</b>
            {` ${parseFloat(totalesdetraccion?.montodetraccion_other).toFixed(
              2
            )}`}
          </sub>
        </>
      )}
    </>
  );
};
